<template>
    <v-container>
        <v-layout row wrap>
            <v-flex xs12 sm12 md12 class="role" v-for="( role, key ) in roles_list" :key="key">
                <RoleForm :role="role" @remove="fnRemove" :remove="remove"></RoleForm>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
import i18n from '@/i18n'
import RoleForm from '@/components/ui/RoleForm'

export default {
  components: { RoleForm },
  props: { roles: Array, remove: Boolean },
  data () {
    return {
    }
  },
  computed: {
    roles_list(){
        return this.roles
    },

    countries(){
      var oCountries = this.$store.getters.getCountries()
      var aResult = []
      for( var k in oCountries ){
        aResult.push( { text: oCountries[k].name, value: oCountries[k].id } )
      }

      return aResult
    },

    events_active() {
        var aEvents = this.$store.getters['events/getActives']()
        var aResult = []
        var self = this
        aEvents.forEach( event => {
            aResult.push({
                value: event.id,
                text: self.$root.formatEventName( event.name, event.edition )
            })
        })
        return aResult
    },


  },
  methods: {
        getOptions( options, filter, bFirstEmpty ){
            var bFirstEmpty = ( typeof bFirstEmpty === 'undefined' )? false : bFirstEmpty
            if( typeof options === 'string' ){
                var aOptions = [];
                // console.log( options );
                // console.log( filter );
                if( typeof filter.params !== 'undefined' ){
                    var values = this.$store.getters[ options ]( filter.params );
                }
                else{
                    var values = this.$store.getters[ options ]();
                }
                if( bFirstEmpty ) aOptions.push( { value: -1, text: i18n.t( filter.label ) } );
                for( var i in values ){
                    var value = values[i];
                    name = ( typeof filter.translate === 'undefined' || filter.translate )? i18n.t( value.name ) : value.name;
                    aOptions.push( { value: value.id, text: name } );
                }

                return aOptions;
            }
            else {
                return options;
            }
        },

        loadAutocomplete(event, param) {
            this.param_autocomplete = param.param;
            clearTimeout( this.toAutoComplete );
            var self = this;
            this.toAutoComplete = setTimeout( function(){
                if (event.target.value.length > 2) {
                self.$store.dispatch( param.action, event.target.value ).then( function(){
                    var aResults = self.$store.getters[ param.getter ]();
                    var aResult = [];
                    for( var k in aResults ){
                    var result = aResults[k];
                    aResult.push( { text: result.name, value: result.id } );
                    }

                    self.cAutoComplete = aResult;
                })
                }
            }, 200 );
        },
        
        addThumbnail( param ){
            this.param_select = param;
            this.$refs[param].click();
        },
        onThumbnailPicked (e) {
            const files = e.target.files;
            var self = this;
            if(files[0] !== undefined) {
                if(this.clipper) URL.revokeObjectURL(this.clipper)
                this.clipper = window.URL.createObjectURL(e.target.files[0]);
            }
        },
        showThumb( image ){
        // console.log( image );
            this.clipper = false;
            this.$refs[ this.param_select ].value = null;
            this.person[ this.param_select + '_preview' ] = image;

            function dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            }
            
            if( image ){
                this.person[ this.param_select ] = dataURLtoFile( image, this.param_select + '_' + moment().valueOf() + '.jpg' );
            }
        },
        fnRemove( id ){
            var self = this
            this.$popup.confirm({
                message: i18n.t( "roles.delete" ),
                btnSuccess: i18n.t( 'accept' ),
                btnError: i18n.t( 'cancel' )
            }, function(){
                self.$emit( "remove", id )
            },
            function(){
                self.$comboSelector.close();
            })
        }

  },
  created() {
      var self = this;
  },

  watch: {
        // roles: {
        //     handler: function (after, before) {
        //         // Return the object that changed
        //         let changed = after.filter( function( p, idx ) {
        //             return Object.keys(p).some( function( prop ) {
        //                 return p[prop] !== before[idx][prop];
        //             })
        //         })
        //         // Log it
        //         console.log(changed)
        //     },
        //     deep: true
        // }
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  #notes-container {
    padding: 20px;
    width: 100%;
    
    .title {
      padding-bottom: 5px;
      border-bottom: 2px solid $complem-color-dark;
      width: calc( 100% - 200px );
    }

    .button.add {
      max-width: 200px;
      height: 35px;
      float: right;
      margin-top: -25px;
            padding: 8px 20px;
            padding-left: 35px;
            text-align: center;
            margin-right: 15px;
            border-radius: 3px;
            font-size: 12px;
            text-transform: uppercase;
            color: #fff;
            cursor: pointer;
            background: url('/img/add.svg') no-repeat left 10px center $complem-color;
            background-size: 15px;

          &:hover {
            background-color: $complem-color-dark;
          }
    }

    .note_list {
        display: block;
        padding: 20px;
        overflow: hidden;
        width: 100%;
    
        .note {
            max-width: 300px;
            width: calc( 33% - 20px );
            @include  box-shadow( $h: 0px , $v: 3px , $b: 8px , $s: 0px , $c: #00000011 );
            border-radius: 3px;
            padding: 20px 20px 30px 20px;
            max-height: 150px;
            height: 150px;
            float: left;
            position: relative;
            background-color: #fff;
            margin-top: 15px;
            margin-left: 15px;

            &.empty {
                padding: 20px;
                font-size: 20px;
                height: 60px;
                text-transform: uppercase;
            }

            .text {
                overflow: hidden;
                text-overflow: ellipsis;
                word-wrap: break-word;
                display: -webkit-box;
                line-height: 16px;     /* fallback */
                max-height: 120px;      /* fallback */
                -webkit-line-clamp: 5; /* number of lines to show */
                -webkit-box-orient: vertical;
                @include font-size(14px);
            }
            .meta {
              @include font-size(12px);
              position: absolute;
              bottom: 0px;
              left: 0;
              width: 100%;
              overflow: hidden;
              padding: 10px 20px;
              color: #999;

              .date {
                display: inline-block;
                @include font-size(12px);
                color: #999;
                margin-left: 10px;
              }
              .author {
                display: inline-block;
                @include font-size(12px);
                color: #999;
                font-weight: bold;
              }
              
            }

            &:not(:first-child) {
                /*margin-left: 20px;*/
            }
        }
    }
  }


</style>